import { jsx as p } from "react/jsx-runtime";
import { memo as a, useMemo as n, lazy as g, Suspense as c } from "react";
import { useComponentToggleContext as h } from "../ComponentToggleProvider/context.js";
const x = ({
  feature: r,
  renderFallback: e,
  ...s
}) => {
  const { flags: o, importFn: m, maxFeatureDepth: l = 1 } = h(), t = n(() => r.split("/"), [r]);
  if (t.length > l)
    throw new Error(`Max feature depth is ${l}`);
  const u = n(() => g(() => m(t)), [t, m]);
  return n(
    () => o && Object.entries(o).some(([i, f]) => i.split("/")[0] === t[0] && f),
    [o, t]
  ) ? /* @__PURE__ */ p(c, { fallback: null, children: /* @__PURE__ */ p(u, { ...s.componentProps, children: s.children }) }) : (e == null ? void 0 : e()) ?? null;
}, j = a(x);
export {
  x as InternalComponentToggle,
  j as default
};
